import { TimeZone } from "../models/time-zone-interface";
import { api } from "../utilites/api";

export const TimeZoneApi = {
  getTimeZones: () : Promise<TimeZone[]> => api.get(`timezone/getTimeZoneList`),
}